export type PeriodErrors = {
  periodStart?: string;
  periodEnd?: string;
};

export const validatePeriod = (
  periodStart: string | null | undefined,
  periodEnd: string | null | undefined,
): PeriodErrors => {
  const errors: PeriodErrors = {};

  if (periodStart && periodEnd) {
    const startDate = new Date(periodStart);
    const endDate = new Date(periodEnd);

    if (startDate > endDate) {
      errors.periodStart = 'Начало не может быть позже конца';
      errors.periodEnd = 'Конец не может быть раньше начала';
    }
  }

  return errors;
};
